import React from 'react';
import { FormModal } from 'components/common';
import { Col, Form, Row, Select } from 'components';
import { useAssignmentEdit } from './useAssignmentEdit';
import { ManagementRoleMapping } from '../../../../../../../models/Manager';

export interface IAssignmentUpdate {
  onCancel: () => void;
  open: boolean;
}

export const AssignmentEditModal = React.memo((props: IAssignmentUpdate) => {
  const { onCancel: onCancelModal, open } = props;
  const { form, isLoadingUpdate, onFinish, onCancel, userData, handleManagerChange } = useAssignmentEdit({
    onCancelModal,
    open,
  });

  return (
    <FormModal
      form={form}
      width={600}
      title={'Update Assignments'}
      okText={'Save'}
      open={open}
      isLoading={isLoadingUpdate}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label={ManagementRoleMapping.postSalesManager} name={'postSalesManagerId'}>
            <Select
              size={'large'}
              options={userData}
              onSelect={(value) => handleManagerChange(value, 'postSalesManagerAssistantId')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.postSalesManagerId !== currentValues.postSalesManagerId
            }
          >
            {({ getFieldValue }) => {
              return (
                <Form.Item label={ManagementRoleMapping.postSalesManagerAssistant} name={'postSalesManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('postSalesManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('postSalesManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
});
